export default "__VITE_ASSET__DvoPZe78__"